import axios from 'axios';
import endpointPaths from './endpointPaths';

// ES6 Modules or TypeScript
import Swal from 'sweetalert2'


// Add a response interceptor
axios.interceptors.response.use(function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function(error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    console.log(error)
    if (error.response.status === 401) {
        localStorage.removeItem('accessToken')
        setTimeout(() => {
            window.location.href = '/login'
        }, 1000);
    }

    if (error.response.status === 422) {
        Swal.fire({
            title: "Hata!",
            text: error.response.data.message,
            icon: "error",
            confirmButtonText: "Tamam",
            customClass: {
                confirmButton: "btn btn-primary",
            },
        })

    }
});

let accessToken = localStorage.accessToken

let axiosConfigApplicationJsonNoAuth = {
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    }
};

let axiosConfigApplicationJson = {
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': `Bearer ${accessToken}`
    }
};

let axiosConfigMultipartFormData = {

    headers: {
        'Content-Type': 'multipart/form-data',
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': `Bearer ${accessToken}`
    }
};


export class Endpoints {

    constructor() {
            this.setAuthorizationToken()
        }
        // Auth Start 
    setAuthorizationToken() {
        accessToken = localStorage.getItem('accessToken')
        axiosConfigApplicationJson = {
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Authorization': `Bearer ${accessToken}`
            }
        };
        axiosConfigMultipartFormData = {

            headers: {
                'Content-Type': 'multipart/form-data',
                'X-Requested-With': 'XMLHttpRequest',
                'Authorization': `Bearer ${accessToken}`
            }
        };
    }

    postLogin = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.auth.login}?locale=${locale}`, req, axiosConfigApplicationJsonNoAuth);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    // Auth End 

    //Languages Start

    getLanguages = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.languages.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getLanguageById = async(id, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.languages.getById}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    postLanguage = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.languages.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putLanguage = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.languages.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    putLanguagesOrder = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.languages.putOrder}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    deleteLanguage = async(id, locale, res) => {
            try {
                let response = await axios.delete(`${endpointPaths.languages.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
                return response.data;
            } catch (error) {
                return error;
            }
        }
        //Languages End
        //Translations Start
    getTranslations = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.translations.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getTranslationById = async(id, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.translations.getById}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    postTranslation = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.translations.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putTranslation = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.translations.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    putTranslationsOrder = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.translations.putOrder}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    deleteTranslation = async(id, locale, res) => {
            try {
                let response = await axios.delete(`${endpointPaths.translations.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
                return response.data;
            } catch (error) {
                return error;
            }
        }
        //Translations End

    //Devices Start

    getDevices = async(page, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.devices.get}?page=${page}&locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    getDeviceById = async(id, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.devices.getById}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    postDevices = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.devices.post}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    putDevices = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.devices.put}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    deleteDevices = async(id, locale, res) => {
        try {
            let response = await axios.delete(`${endpointPaths.devices.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    //Devices End

    //Users Start
    getUsers = async(page, locale, res) => {
        try {
            let response = await axios.get(
                `${endpointPaths.users.get}?page=${page}&locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postUsers = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.users.post}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    putUsers = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.users.put}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    getUserById = async(id, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.users.getById}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    //Users  End
    //Airports Start
    getAirports = async(page, locale, res) => {
        try {
            let response = await axios.get(
                `${endpointPaths.airports.get}?page=${page}&locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getAllAirports = async(page, locale, res) => {
        try {
            let response = await axios.get(
                `${endpointPaths.airports.getAll}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postAirports = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.airports.post}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }


    deleteAirports = async(id, locale, res) => {
            try {
                let response = await axios.delete(`${endpointPaths.airports.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
                return response.data;
            } catch (error) {
                return error;
            }
        }
        //Airports  End
        //Products Start

    getProducts = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.products.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getProductById = async(id, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.products.getById}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    postProduct = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.products.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    postProductTranslation = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.products.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putProductTranslation = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.products.putTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    putProductsOrder = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.products.putOrder}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    deleteProduct = async(id, locale, res) => {
            try {
                let response = await axios.delete(`${endpointPaths.products.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
                return response.data;
            } catch (error) {
                return error;
            }
        }
        //Prodcuts End


    //Airport Products Start
    getAirportProductsById = async(id, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.airportProducts.getById}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    postAirportProduct = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.airportProducts.post}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }


    //Airport Products End

    //Questions Start


    getQuestions = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.questions.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getQuestionById = async(id, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.questions.getById}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    postQuestion = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.questions.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    postQuestionTranslation = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.questions.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putQuestionTranslation = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.questions.putTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    putQuestionsOrder = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.questions.putOrder}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    deleteQuestion = async(id, locale, res) => {
            try {
                let response = await axios.delete(`${endpointPaths.questions.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
                return response.data;
            } catch (error) {
                return error;
            }
        }
        //Questions End
        //ProductQuestions Start

    getProductQuestionsById = async(id, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.productQuestions.getById}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    getProductQuestionById = async(id, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.productQuestions.getQuestionById}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }


    postProductQuestion = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.productQuestions.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    putProductQuestion = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.productQuestions.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }

    putProductQuestionsOrder = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.productQuestions.putOrder}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteProductQuestion = async(id, locale, res) => {
            try {
                let response = await axios.delete(`${endpointPaths.productQuestions.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
                return response.data;
            } catch (error) {
                return error;
            }
        }
        // ProductQuestions End 


    //Analysis Results Start
    getAnalysisResults = async(page, startDate, endDate, locale, res) => {
        try {
            let response = await axios.get(
                `${endpointPaths.analysisResults.get}?startDate=${startDate}&endDate=${endDate}&page=${page}&locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getAnalysisResultById = async(id, locale, res) => {
            try {
                let response = await axios.get(`${endpointPaths.analysisResults.getById}/${id}?locale=${locale}`, axiosConfigApplicationJson);
                return response.data;
            } catch (error) {
                return error;
            }

        }
        //Analysis Results




    // Events Start 
    getEvents = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.events.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getEventsBySlug = async(slug, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.events.get}/${slug}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getEventTypes = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.eventTypes.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postEvents = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.events.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putEvents = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.events.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postEventsTranslation = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.events.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postEventsAvailability = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.events.postAvailability}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putEventsOrder = async(req, locale, res) => {
        try {
            let response = await axios.put(`${endpointPaths.events.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteEvents = async(slug, locale, res) => {
            try {
                let response = await axios.delete(`${endpointPaths.events.delete}/${slug}?locale=${locale}`, axiosConfigApplicationJson);
                return response.data;
            } catch (error) {
                return error;
            }
        }
        // Sliders Start 
    getSliders = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.sliders.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getSlidersById = async(id, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.sliders.get}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postSliders = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.sliders.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putSliders = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.sliders.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postSlidersTranslation = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.sliders.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putSlidersOrder = async(req, locale, res) => {
        try {
            let response = await axios.put(`${endpointPaths.sliders.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteSliders = async(id, locale, res) => {
        try {
            let response = await axios.delete(`${endpointPaths.sliders.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    // Educators Start 
    getEducators = async(req, locale, res) => {
            try {
                let response = await axios.get(`${endpointPaths.educators.get}?locale=${locale}`, axiosConfigApplicationJson);
                return response.data;
            } catch (error) {
                return error;
            }

        }
        // Educators Start 
    getEducatorsType = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.educators.get}?locale=${locale}&type=${req}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getEducatorsBySlug = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.educators.get}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postEducators = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.educators.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putEducators = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.educators.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postEducatorsTranslation = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.educators.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postEducatorsAvailability = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.educators.postAvailability}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putEducatorsOrder = async(req, locale, res) => {
        try {
            let response = await axios.put(`${endpointPaths.educators.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteEducators = async(id, locale, res) => {
            try {
                let response = await axios.delete(`${endpointPaths.educators.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
                return response.data;
            } catch (error) {
                return error;
            }
        }
        // Contents Start 
    postContentsTranslation = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.contents.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postContents = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.contents.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putContents = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.contents.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getContents = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.contents.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getContentsBySlug = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.contents.get}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getContentsByCategorySlug = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.contents.getByCategorySlug}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postContentsAvailability = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.contents.postAvailability}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putContentsOrder = async(req, locale, res) => {
        try {
            let response = await axios.put(`${endpointPaths.contents.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteContents = async(id, locale, res) => {
        try {
            let response = await axios.delete(`${endpointPaths.contents.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    //  Books Start 

    getBooks = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.books.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getBooksById = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.books.get}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postBooks = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.books.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putBooks = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.books.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postBooksTranslation = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.books.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putBooksOrder = async(req, locale, res) => {
        try {
            let response = await axios.put(`${endpointPaths.books.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteBooks = async(id, locale, res) => {
        try {
            let response = await axios.delete(`${endpointPaths.books.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    //  Podcasts Start 

    getPodcasts = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.podcasts.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    getPodcastsBySlug = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.podcasts.get}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postPodcasts = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.podcasts.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putPodcasts = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.podcasts.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postPodcastsTranslation = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.podcasts.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putPodcastsOrder = async(req, locale, res) => {
        try {
            let response = await axios.put(`${endpointPaths.podcasts.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postPodcastsAvailability = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.podcasts.postAvailability}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    deletePodcasts = async(id, locale, res) => {
        try {
            let response = await axios.delete(`${endpointPaths.podcasts.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    //  Categories Start 
    getCategories = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.categories.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getCategoriesTree = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.categories.getTree}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getCategoriesBySlug = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.categories.get}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getCategoriesBySlugFlat = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.categories.getFlat}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getCategoriesAttributesById = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.categories.getAttributes}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postCategories = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.categories.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postCategoriesTranslation = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.categories.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putCategories = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.categories.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    putCategoriesOrder = async(req, locale, res) => {
        try {
            let response = await axios.put(`${endpointPaths.categories.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteCategories = async(id, locale, res) => {
        try {
            let response = await axios.delete(`${endpointPaths.categories.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    getGalleriesBySlug = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.galleries.get}/${req}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putGalleries = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.galleries.put}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    postGalleries = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.galleries.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postGalleriesAvailability = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.galleries.postAvailability}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getGalleries = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.galleries.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postGalleriesTranslation = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.galleries.postTranslation}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postGalleriesTranslation = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.galleries.postTranslation}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putGalleriesOrder = async(req, locale, res) => {
        try {
            let response = await axios.put(`${endpointPaths.galleries.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteGalleries = async(id, locale, res) => {
        try {
            let response = await axios.delete(`${endpointPaths.galleries.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    getSettingsSliderHighlights = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.settingsSliderHighlights.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postSettingsSliderHighlights = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.settingsSliderHighlights.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putSettingsSliderHighlightsOrder = async(req, locale, res) => {
        try {
            let response = await axios.put(`${endpointPaths.settingsSliderHighlights.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteSettingsSliderHighlights = async(id, locale, res) => {
        try {
            let response = await axios.delete(`${endpointPaths.settingsSliderHighlights.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getSettingsSliderPrograms = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.settingsSliderPrograms.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postSettingsSliderPrograms = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.settingsSliderPrograms.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putSettingsSliderProgramsOrder = async(req, locale, res) => {
        try {
            let response = await axios.put(`${endpointPaths.settingsSliderPrograms.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteSettingsSliderPrograms = async(id, locale, res) => {
        try {
            let response = await axios.delete(`${endpointPaths.settingsSliderPrograms.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getSettingsSliderInteresteds = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.settingsSliderInteresteds.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postSettingsSliderInteresteds = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.settingsSliderInteresteds.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    putSettingsSliderInterestedsOrder = async(req, locale, res) => {
        try {
            let response = await axios.put(`${endpointPaths.settingsSliderInteresteds.order}?locale=${locale}`, req, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }

    }
    deleteSettingsSliderInteresteds = async(id, locale, res) => {
        try {
            let response = await axios.delete(`${endpointPaths.settingsSliderInteresteds.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getSettingsSliderPodcasts = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.settingsSliderPodcasts.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    postSettingsSliderPodcasts = async(req, locale, res) => {
        try {
            let response = await axios.post(`${endpointPaths.settingsSliderPodcasts.post}?locale=${locale}`, req, axiosConfigMultipartFormData);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    deleteSettingsSliderPodcasts = async(id, locale, res) => {
        try {
            let response = await axios.delete(`${endpointPaths.settingsSliderPodcasts.delete}/${id}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    getSliderLinkTypes = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.sliderLinkTypes.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getGalleryCategories = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.galleryCategories.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getLanguages = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.languages.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getCategoryTypes = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.categoryTypes.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    getContentTypes = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.contentTypes.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getFormGsys = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.form.gsys.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getFormContacts = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.form.contacts.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getFormNewsletters = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.form.newsletters.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }
    getFormParticipants = async(req, locale, res) => {
        try {
            let response = await axios.get(`${endpointPaths.form.participants.get}?locale=${locale}`, axiosConfigApplicationJson);
            return response.data;
        } catch (error) {
            return error;
        }
    }

}